const STORAGE_KEYS = {
  GAME_STATE: 'mokugyo_game_state',
  LAST_LOGIN: 'mokugyo_last_login',
  LOGIN_STREAK: 'mokugyo_login_streak'
};

// 檢測是否在沙盒環境
const isSandboxed = (() => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
})();

// 檢測localStorage是否可用
const isLocalStorageAvailable = () => {
  try {
    const testKey = 'test_' + Date.now();
    localStorage.setItem(testKey, testKey);
    localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
};

// 載入遊戲狀態
export const loadGameState = async () => {
  try {
    if (isLocalStorageAvailable()) {
      const savedState = localStorage.getItem(STORAGE_KEYS.GAME_STATE);
      if (savedState) {
        return JSON.parse(savedState);
      }
    }
    return null;
  } catch (error) {
    console.error('載入遊戲狀態失敗:', error);
    return null;
  }
};

// 儲存遊戲狀態
export const saveGameState = async (state) => {
  try {
    if (isLocalStorageAvailable()) {
      localStorage.setItem(STORAGE_KEYS.GAME_STATE, JSON.stringify(state));
      return true;
    }
    return false;
  } catch (error) {
    console.error('儲存遊戲狀態失敗:', error);
    return false;
  }
};

// 載入登入資訊
export const loadLoginData = async () => {
  try {
    if (isLocalStorageAvailable()) {
      const lastLogin = localStorage.getItem(STORAGE_KEYS.LAST_LOGIN);
      const loginStreak = localStorage.getItem(STORAGE_KEYS.LOGIN_STREAK);
      
      return {
        lastLogin: lastLogin || '',
        loginStreak: parseInt(loginStreak) || 0
      };
    }
    return { lastLogin: '', loginStreak: 0 };
  } catch (error) {
    console.error('載入登入資訊失敗:', error);
    return { lastLogin: '', loginStreak: 0 };
  }
};

// 儲存登入資訊
export const saveLoginData = async (lastLogin, loginStreak) => {
  try {
    if (isLocalStorageAvailable()) {
      localStorage.setItem(STORAGE_KEYS.LAST_LOGIN, lastLogin);
      localStorage.setItem(STORAGE_KEYS.LOGIN_STREAK, loginStreak.toString());
      return true;
    }
    return false;
  } catch (error) {
    console.error('儲存登入資訊失敗:', error);
    return false;
  }
};